import { ProductEditCommandModel } from "../product-base-model";

export class SpecialServiceEditCommandModel extends ProductEditCommandModel {
    public seasonCode: string;
}